(() => {
  const initMenu = () => {
    const button = document.querySelector('[data-menu-button]');
    const nav = document.querySelector('[data-site-menu]');
    if (!button || !nav) return;
    const setOpen = (open) => {
      nav.classList.toggle('nav-open', open);
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? 'Close' : 'Index';
    };
    button.addEventListener('click', () => setOpen(!nav.classList.contains('nav-open')));
    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => event.key === 'Escape' && setOpen(false));
  };

  const initRepairMap = () => {
    const shell = document.querySelector('[data-part92-shell]');
    if (!shell) return;
    const trigger = shell.querySelector('[data-camera-trigger]');
    const close = shell.querySelector('[data-inspection-close]');
    const label = shell.querySelector('[data-click-label]');
    const mapLinks = shell.querySelectorAll('[data-repair-code]');
    const hotspots = shell.querySelectorAll('[data-hotspot-code]');

    const setInspection = (open) => {
      shell.classList.toggle('is-inspecting', open);
      trigger?.setAttribute('aria-pressed', String(open));
      trigger?.setAttribute('aria-label', open ? 'Close accurate Ricoh GR exploded view' : 'Open accurate Ricoh GR exploded view');
      if (label) label.textContent = open ? 'Return to camera' : 'Explore repair map';
      if (!open) setActive(null);
    };
    const setActive = (code) => {
      mapLinks.forEach((item) => item.classList.toggle('is-active', item.dataset.repairCode === code));
      hotspots.forEach((item) => item.classList.toggle('is-active', item.dataset.hotspotCode === code));
    };

    trigger?.addEventListener('click', () => setInspection(!shell.classList.contains('is-inspecting')));
    close?.addEventListener('click', () => setInspection(false));
    mapLinks.forEach((link) => {
      link.addEventListener('mouseenter', () => setActive(link.dataset.repairCode));
      link.addEventListener('mouseleave', () => setActive(null));
      link.addEventListener('focus', () => setActive(link.dataset.repairCode));
      link.addEventListener('blur', () => setActive(null));
    });
    document.addEventListener('keydown', (event) => event.key === 'Escape' && setInspection(false));
  };

  const initLocalization = () => {
    document.querySelectorAll('[data-localization-select]').forEach((select) => {
      select.addEventListener('change', () => select.form?.submit());
    });
  };

  const initRepairFilters = () => {
    document.querySelectorAll('[data-repair-filter-root]').forEach((root) => {
      const tabs = Array.from(root.querySelectorAll('[data-repair-filter]'));
      const panels = Array.from(root.querySelectorAll('[data-repair-panel]'));
      if (!tabs.length || !panels.length) return;

      const availableModels = tabs.map((tab) => tab.dataset.repairFilter);
      const activate = (model, { focus = false, updateUrl = false } = {}) => {
        const activeModel = availableModels.includes(model) ? model : availableModels[0];
        tabs.forEach((tab) => {
          const active = tab.dataset.repairFilter === activeModel;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          tab.classList.toggle('is-active', active);
          if (active && focus) tab.focus();
        });
        panels.forEach((panel) => {
          const active = panel.dataset.repairPanel === activeModel;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });

        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('model', activeModel);
          window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        }
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.repairFilter, { updateUrl: true }));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          activate(tabs[nextIndex].dataset.repairFilter, { focus: true, updateUrl: true });
        });
      });

      const requestedModel = new URLSearchParams(window.location.search).get('model');
      const hashTarget = window.location.hash ? document.getElementById(decodeURIComponent(window.location.hash.slice(1))) : null;
      const hashPanel = hashTarget?.closest('[data-repair-panel]');
      activate(hashPanel?.dataset.repairPanel || requestedModel || availableModels[0]);
      if (hashTarget) window.requestAnimationFrame(() => hashTarget.scrollIntoView({ block: 'start' }));
    });
  };

  const init = () => { initMenu(); initRepairMap(); initLocalization(); initRepairFilters(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
